import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowUp: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-up,arrow-top"><path d="M12 20.25V4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.75 10L12 3.75L18.25 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowUp;
